import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { FiArrowLeft, FiDownload } from 'react-icons/fi';
import BottomTabMenu from '../../components/UI/BottomTabMenu';
import { LoadingGrid } from '../../components/UI/Loading';
import { vendedoresService } from '../../services';

const VendedorComisiones = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [comisiones, setComisiones] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    loadComisiones();
  }, [id]);

  const loadComisiones = async () => {
    setIsLoading(true);
    setError(null);

    try {
      const result = await vendedoresService.getComisionesVendedor(id);

      if (result.success) {
        // Transformar los datos de la API
        const comisionesData = result.data.map(comision => ({
          id: comision.id,
          periodo: comision.period || comision.month || 'N/A',
          ventas: parseFloat(comision.sales_amount || comision.total_sales || 0),
          porcentaje: parseFloat(comision.commission_percentage || comision.percentage || 0),
          comision: parseFloat(comision.commission_amount || comision.amount || 0),
          estado: comision.paid || comision.status === 'PAID' ? 'Pagada' : 'Pendiente'
        }));
        setComisiones(comisionesData);
      } else {
        setError(result.message || 'Error al cargar las comisiones');
        setComisiones([]);
      }
    } catch (err) {
      console.error('Error cargando comisiones:', err);
      setError('Error de conexión al cargar las comisiones');
      setComisiones([]);
    } finally {
      setIsLoading(false);
    }
  };

  const handleExport = () => {
    console.log('Exportar reporte de comisiones del vendedor:', id);
    alert('Función de exportación próximamente');
  };

  if (isLoading) {
    return <LoadingGrid message="Cargando reporte de comisiones..." />;
  }

  return (
    <div className="vendedor-comisiones-page">
      {/* Error message */}
      {error && (
        <div className="alert alert--danger" style={{ margin: '20px' }}>
          <strong>Error:</strong> {error}
          <button
            className="btn btn--ghost btn--sm"
            onClick={loadComisiones}
            style={{ marginLeft: '10px' }}
          >
            Reintentar
          </button>
        </div>
      )}

      {/* Header */}
      <div className="form-header">
        <button
          className="btn btn--ghost"
          onClick={() => navigate('/system/vendedores')}
          type="button"
        >
          <FiArrowLeft /> Volver a Vendedores
        </button>

        <h1 className="form-title">
          REPORTE DE COMISIONES
        </h1>

        <div className="form-actions">
          <button
            className="btn btn--primary"
            onClick={handleExport}
            type="button"
          >
            <FiDownload /> Exportar
          </button>
        </div>
      </div>

      {/* Contenido */}
      <div className="page-content">
        <div className="table-container">
          <table className="data-table">
            <thead>
              <tr>
                <th>PERIODO</th>
                <th className="text-right">VENTAS</th>
                <th className="text-center">%</th>
                <th className="text-right">COMISIÓN</th>
                <th className="text-center">ESTADO</th>
              </tr>
            </thead>
            <tbody>
              {comisiones.map((comision) => (
                <tr key={comision.id}>
                  <td><strong>{comision.periodo}</strong></td>
                  <td className="text-right">${comision.ventas.toLocaleString()}</td>
                  <td className="text-center">
                    <span className="badge badge-warning">{comision.porcentaje}%</span>
                  </td>
                  <td className="text-right">
                    <strong style={{ color: '#28a745' }}>${comision.comision.toLocaleString()}</strong>
                  </td>
                  <td className="text-center">
                    <span className={`badge ${comision.estado === 'Pagada' ? 'badge-activo' : 'badge-warning'}`}>
                      {comision.estado}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Menú inferior */}
      <BottomTabMenu
        baseRoute={`/system/vendedores/${id}`}
        currentTab="comisiones"
        tabs={[
          { id: 'datos', label: 'Datos', route: '' },
          { id: 'ventas', label: 'Reporte de Ventas', route: '/ventas' },
          { id: 'comisiones', label: 'Reporte de Comisiones', route: '/comisiones' },
          { id: 'clientes', label: 'Lista de Clientes', route: '/clientes' },
          { id: 'grafica', label: 'Gráfica de Ventas', route: '/grafica' },
          { id: 'notas', label: 'Notas', route: '/notas' }
        ]}
      />
    </div>
  );
};

export default VendedorComisiones;
